import React, { useEffect, useRef, useState } from "react";

interface PopupProps {
  x: number;
  y: number;
  description: string; // Description to display
}

const Popup: React.FC<PopupProps> = ({ x, y, description }) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [popupPosition, setPopupPosition] = useState({ x, y });

  useEffect(() => {
    const parentContainer = document.getElementById("area-map");
    if (parentContainer && popupRef.current) {
      const parentRect = parentContainer.getBoundingClientRect();
      const popupRect = popupRef.current.getBoundingClientRect();

      let newX = x - popupRect.width/4;
      let newY = y - popupRect.height;

      // Check if popup overflows on the right side
      if (x + popupRect.width > parentRect.right) {
        newX = parentRect.right - popupRect.width;
      }

      // Check if popup overflows on the left side
      if (x < parentRect.left) {
        newX = parentRect.left;
      }

      // Check if popup overflows on the bottom side
      if (y + popupRect.height > parentRect.bottom) {
        newY = parentRect.bottom - popupRect.height;
      }

      // Check if popup overflows on the top side
      if (y < parentRect.top) {
        newY = parentRect.top;
      }

      setPopupPosition({ x: newX, y: newY });
    }
  }, [x, y]);

  return (
    <div
      ref={popupRef}
      className="area-popup"
      style={{
        left: `${popupPosition.x}px`,
        top: `${popupPosition.y}px`,
      }}
    >
      <h4>Area Description</h4>
      <div>{description}</div>
    </div>
  );
};

export default Popup;